export const MEETING_LINKS_SECTION_TEXT = {
    id: 'oe.meetingLinks',
    defaultMessage: 'Meeting Links',
    description: 'Meeting Links section title',
};

export const CONNECTION_COLUMN_TEXT = {
    id: 'oe.meetingLinks.connection',
    defaultMessage: 'Connection',
    description: 'Connection table column header',
};

export const ADD_MEETING_LINK_BUTTON_TEXT = {
    id: 'oe.meetingLinks.addMeetingLink',
    defaultMessage: '+ Add Meeting Link',
    description: 'Add meeting link button text',
};

export const ADD_MEETING_LINK_MODAL_TITLE = {
    id: 'oe.meetingLinks.addModalTitle',
    defaultMessage: 'Add Meeting Link',
    description: 'Add Meeting Link modal title',
};

export const EDIT_MEETING_LINK_MODAL_TITLE = {
    id: 'oe.meetingLinks.editModalTitle',
    defaultMessage: 'Edit Meeting Link',
    description: 'Edit Meeting Link modal title',
};

export const MEETING_LINK_ADDED_TEXT = {
    id: 'oe.meetingLinks.addedNotification',
    defaultMessage: 'Meeting Link Added',
    description: 'Toast shown after a meeting link is created',
};

export const MEETING_LINK_UPDATED_TEXT = {
    id: 'oe.meetingLinks.updatedNotification',
    defaultMessage: 'Meeting Link Updated',
    description: 'Toast shown after a meeting link is updated',
};

export const MEETING_LINK_LABEL_TEXT = {
    id: 'oe.meetingLinks.label',
    defaultMessage: 'Label',
    description: 'Meeting link label field',
};

export const MEETING_LINK_ROLE_TEXT = {
    id: 'oe.meetingLinks.role',
    defaultMessage: 'Role',
    description: 'Meeting link role field',
};

export const CREATE_PANELIST_LINK_TOGGLE_TEXT = {
    id: 'oe.meetingLinks.createPanelistLink',
    message: 'Create Panelist Link {suffix}',
    description: 'Create Panelist Link toggle label on Add/Edit Meeting Link',
};

export const CREATE_PANELIST_LINK_TOGGLE_INFO_TEXT = {
    id: 'oe.meetingLinks.createPanelistLink.info',
    defaultMessage: 'When enabled if the Meeting link has a webinar assigned as the connection or a webinar is part of the connection group, the meeting link will automatically generate a panelist connection for the user joining the meeting link',
    description: 'Info icon copy for the Create Panelist Link toggle',
};

export const MEETING_LINK_URL_TEXT = {
    id: 'oe.meeting.link',
    defaultMessage: 'Meeting Link',
    description: 'Meeting link URL field label',
};

export const NONE_CONNECTION_TYPE = 'None';
export const GROUP_CONNECTION_TYPE = 'Group';
